import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import CommentSection from './CommentSection';

interface CommentModalProps {
  isOpen: boolean;
  onClose: () => void;
  willId: string;
  willTitle: string;
}

const CommentModal: React.FC<CommentModalProps> = ({
  isOpen,
  onClose,
  willId,
  willTitle,
}) => {
  // Handle escape key to close the panel
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onClose]);

  return (
    <div 
      className={`fixed right-0 top-0 z-40 h-screen w-[320px] sm:w-[350px] bg-white shadow-lg transform transition-transform duration-300 ease-in-out border-l border-gray-200 
      ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}
    >
      <div className="flex items-center justify-between px-4 py-2 border-b">
        <h3 className="text-lg font-medium truncate">{willTitle}</h3>
        <button 
          onClick={onClose}
          className="p-1 rounded-sm opacity-70 hover:opacity-100 focus:outline-none ml-2 flex-shrink-0"
        >
          <X className="h-5 w-5" />
          <span className="sr-only">Close</span>
        </button>
      </div>
      
      <div className="h-[calc(100vh-56px)]">
        <CommentSection 
          willId={willId} 
          onClose={onClose} 
          isModal={true} 
          initialCommentsToShow={3}
        />
      </div>
    </div>
  );
};

export default CommentModal; 